import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import OurAppsLayout from "./containers";
import { LocaleProvider } from "./context/locale-provider";
import { getFloor } from "./utilities/webContextUtils";
import { trackPageEvent } from "./utilities/trackPageEvent";

export default function App({ storeData }) {
  const { imageLinksDesktop } = storeData;
  const { imageLinksMobile } = storeData;
  const [floor, setFloor] = useState(null);

  useEffect(() => {
    const currentFloor = getFloor();
    setFloor(currentFloor);

    const trackEvent = async () => {
      try {
        await trackPageEvent();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to track page event:", error);
      }
    };

    trackEvent();
  }, []);

  return (
    <div>
      <LocaleProvider languageStrings={storeData.languageStrings}>
        <OurAppsLayout
          imageLinksDesktop={imageLinksDesktop}
          imageLinksMobile={floor && imageLinksMobile[floor]}
        />
      </LocaleProvider>
    </div>
  );
}

App.propTypes = {
  storeData: PropTypes.object.isRequired,
};
